import { render, staticRenderFns } from "./RegraConcatenacao.vue?vue&type=template&id=465d8090&scoped=true"
import script from "./RegraConcatenacao.vue?vue&type=script&lang=js"
export * from "./RegraConcatenacao.vue?vue&type=script&lang=js"
import style0 from "./RegraConcatenacao.vue?vue&type=style&index=0&id=465d8090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d8090",
  null
  
)

export default component.exports